export default __webpack_public_path__ + "assets/front/scss/common.f6beca3a2a1c69b2e044c9e567c84fce.css";